module.exports = __webpack_public_path__ + "static/tatianawork8-2238b347fb6965dbdf2050858de23d8d.jpeg";